import {Component }  from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-wc-confirm',
    templateUrl: './wc-confirm.dialog.html',
    styleUrls: ['./wc-confirm.dialog.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class WcConfirmDialog {

  constructor(public dialogRef: MatDialogRef<WcConfirmDialog>) { }

  onClick(value:boolean) {
    this.dialogRef.close(value);
  }

}
